// Shared constants for employer dashboard
export const TABS = ["All", "Active", "Draft", "Archived"];

export const getStatusConfig = (status) => {
    const statusConfig = {
        'Posted': { color: 'bg-green-100 text-green-700', label: 'Posted' },
        'Draft': { color: 'bg-yellow-100 text-yellow-700', label: 'Draft' },
        'Archived': { color: 'bg-gray-100 text-gray-700', label: 'Archived' }
    };
    return statusConfig[status] || statusConfig['Draft'];
};

export const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} minutes ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    if (diffInSeconds < 2592000) return `${Math.floor(diffInSeconds / 86400)} days ago`;
    if (diffInSeconds < 31536000) return `${Math.floor(diffInSeconds / 2592000)} months ago`;
    return `${Math.floor(diffInSeconds / 31536000)} years ago`;
};

export const jobCategoryColour = {
    'Medical Education': ['bg-purple-50', 'text-purple-700'],
    'Clincial Medicine': ['bg-green-50', 'text-green-700'],
    'Clinical Research': ['bg-blue-50', 'text-blue-700'],
    'Health Tech': ['bg-navy-50', 'text-navy-700'],
    'Hospital Clinic Management': ['bg-blue-50', 'text-blue-700'],
    'Insurance': ['bg-white', 'text-gray-700'],
    'Pharmaceuticals': ['bg-blue-50', 'text-blue-700'],
    'Marketing/Sales': ['bg-orange-50', 'text-orange-700'],
} 

export const getPillColor = ['bg-red-50', 'bg-orange-50', 'bg-green-50', 'bg-blue-50', 'bg-indigo-50', 'bg-purple-50'];
export const getPillTextColor = ['text-red-500', 'text-orange-500', 'text-green-500', 'text-blue-500', 'text-indigo-500', 'text-purple-500'];

